import { Component, OnInit } from '@angular/core';
import { HaCasegroupcreationServiceService } from '../../services/HaCaseGroupCreation.service';
import { Router } from '@angular/router';
import { HaEditIcdModal } from '../../models/HaEditIcd.model';
import { ImportExportCodesService } from '../../services/ImportExportCodes.service';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { CaseCodesEnum } from './CaseCodesEnum';
import { CreateGroupModal } from '../../models/CreateGroup.model';
import { ErrorModel } from '../../../../shared/models/Error.model';
declare var $: any;

@Component({
  selector: 'app-ha-newcasegroupcreation',
  templateUrl: './ha-newcasegroupcreation.component.html',
  styleUrls: ['./ha-newcasegroupcreation.component.css']
})
export class HaNewcasegroupcreationComponent implements OnInit {

  icdAddButton: boolean = false;
  cptAddButton: boolean = false;
  icdDiv: boolean;
  cptDiv: boolean;
  preOpDiv: boolean;
  procDiv: boolean;
  medicalDiv: boolean;
  venDiv: boolean;
  icdAdd: boolean;
  cptAdd: boolean;
  preAdd: boolean;
  procAdd: boolean;
  medAdd: boolean;
  vendorAdd: boolean;
  disableCptAddButton: boolean;
  saveDisable: boolean = true;
  icdList: any[] = [];
  cptList: any[] = [];
  preList: any[] = [];
  procList: any[] = [];
  medList: any[] = [];
  venList: any[] = [];
  dataList: any[];
  icdLoadData: any[] = [];
  cptLoadData: any[] = [];
  preLoadData: any[] = [];
  procLoadData: any[] = [];
  medLoadData: any[] = [];
  vendorLoadData: any[] = [];
  medTextVal: string = "";
  icdTextVal: string = "";
  icdDescVal: string = "";
  cptTextVal: string = "";
  cptDescVal: string = "";
  preTextVal: string = "";
  procTextVal: string = "";
  venTextVal: string = "";
  disableIcdAddButton: boolean;
  changeIcdEdit: boolean = false;
  sendIndex: any;
  showOverlay: boolean;
  showIcdCodeLoader: boolean;
  showCptCodeLoader: boolean;
  showPreCodeLoader: boolean;
  showProcCodeLoader: boolean;
  showMedCodeLoader: boolean;
  showVendorCodeLoader: boolean;
  searchTerm: string = '';
  searchTermProc: string = '';
  searchTermCpt: string = '';
  searchTermPre: string = '';
  searchTermMed: string = '';
  searchTermVen: string = '';
  activeElementCode = '1';
  disablePreAddButton: boolean;
  disableProcAddButton: boolean;
  disableMedAddButton: boolean;
  disableVenAddButton: boolean;
  showSaveLoader: boolean;
  caseGroupList: any[] = [];
  groupVal: string = "";
  nameFieldData: string = "";
  descriptionFieldData: string = "";
  categoryFieldData: string = "";
  helpTextFieldData: string = "";
  nameFieldDataIcd: string = "";
  descriptionFieldDataIcd: string = "";
  categoryFieldDataIcd: string = "";
  helpTextFieldDataIcd: string = "";
  configIcd;
  configCpt;
  icdData: HaEditIcdModal[];
  cptData: HaEditIcdModal[];
  sendAddData: HaEditIcdModal;
  sendAddDataCpt: HaEditIcdModal;
  categoryselectedIcd: string = "";
  categoryselectedCpt: string = "";
  dataModelIcd: any;
  dataModelCpt: any;
  mainViewError = new ErrorModel();
  constructor(private _service: HaCasegroupcreationServiceService, private router: Router, private _serv: ImportExportCodesService) { }

  ngOnInit() {

    this.icdData = [];
    this.configIcd = {
      displayKey: "name", //if objects array passed which key to be displayed defaults to description
      search: true,//true/false for the search functionlity defaults to false,
      height: '150px', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
      placeholder: 'Select',// text to be displayed when no item is selected defaults to Select,
      customComparator: () => { }, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
      limitTo: this.icdData.length, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
      moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
      noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
      searchPlaceholder: 'Search Category', // label thats displayed in search input,
      searchOnKey: 'name' // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
    }

    this.cptData = [];
    this.configCpt = {
      displayKey: "name", //if objects array passed which key to be displayed defaults to description
      search: true,//true/false for the search functionlity defaults to false,
      height: '150px', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
      placeholder: 'Select',// text to be displayed when no item is selected defaults to Select,
      customComparator: () => { }, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
      limitTo: this.cptData.length, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
      moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
      noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
      searchPlaceholder: 'Search Category', // label thats displayed in search input,
      searchOnKey: 'name' // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
    }
    // this.showOverlay = true;
    this.getCodes('1');
    this.getCaseByGroup();

  }


  getCodes(index) {
    this.mainViewError.display = false;
    this.showOverlay = true;

    this.cptLoadData = [];
    this.preLoadData = [];
    this.procLoadData = [];
    this.medLoadData = [];
    this.vendorLoadData = [];
    this._service.getCodesByGroup().subscribe(
    (data: any[]) => {
      this.dataList = data;
      this.icdLoadData = this.dataList["icdCodes"];
      this.cptLoadData = this.dataList["cptCodes"];
      this.preLoadData = this.dataList["preopCodes"];
      this.procLoadData = this.dataList["procedures"];
      this.medLoadData = this.dataList["medDevices"];
      this.vendorLoadData = this.dataList["vendors"];
      this.showIcdCodeLoader = false;
      this.showCptCodeLoader = false;
      this.showPreCodeLoader = false;
      this.showProcCodeLoader = false;
      this.showMedCodeLoader = false;
      this.showVendorCodeLoader = false;
      this.showOverlay = false;
      this.changeDiv(index);
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;

    }).add(() => {
      this.showOverlay = false;
    });
  }




  changeEditCaseCode(codeId, codeType) {

    switch (codeType) {
      case (CaseCodesEnum.Icd): {
        let icdData = this.icdLoadData.findIndex(icd => icd.id == codeId);
        this.icdLoadData[icdData].isEnabled = true;
        break;

      }
      case (CaseCodesEnum.Cpt): {
        let cptData = this.cptLoadData.findIndex(cpt => cpt.id == codeId);
        this.cptLoadData[cptData].isEnabled = true;
        break;

      }
      case (CaseCodesEnum.Preoperatives): {
        let preData = this.preLoadData.findIndex(pre => pre.id == codeId);
        this.preLoadData[preData].isEnabled = true;
        break;
      }
      case (CaseCodesEnum.Procedures): {
        let procData = this.procLoadData.findIndex(proc => proc.id == codeId);
        this.procLoadData[procData].isEnabled = true;
        break;
      }
      case (CaseCodesEnum.MedicalDevices): {
        let medData = this.medLoadData.findIndex(med => med.id == codeId);
        this.medLoadData[medData].isEnabled = true;
        break;
      }
      case (CaseCodesEnum.Vendors): {
        let vendorData = this.vendorLoadData.findIndex(vendor => vendor.id == codeId);
        this.vendorLoadData[vendorData].isEnabled = true;
        break;
      }
    }
  }

  clearTextCodeVal(codeType) {
    switch (codeType) {
      case (CaseCodesEnum.Icd): {
        this.icdTextVal = "";
        this.icdDescVal = "";
        break;
      }
      case (CaseCodesEnum.Cpt): {
        this.cptTextVal = "";
        this.cptDescVal = "";
        break;
      }
      case (CaseCodesEnum.Preoperatives): {
        this.preTextVal = "";
        break;
      }
      case (CaseCodesEnum.Procedures): {
        this.procTextVal = "";
        break;
      }
      case (CaseCodesEnum.MedicalDevices): {
        this.medTextVal = "";
        break;
      }
      case (CaseCodesEnum.Vendors): {
        this.venTextVal = "";
        break;
      }
    }


  }

  changeDiv(codeType) {
    this.showOverlay = false;
    this.sendIndex = codeType;
    this.activeElementCode = codeType;
    this.icdDiv = codeType == CaseCodesEnum.Icd ? true : false;
    this.cptDiv = codeType == CaseCodesEnum.Cpt ? true : false;
    this.preOpDiv = codeType == CaseCodesEnum.Preoperatives ? true : false;
    this.procDiv = codeType == CaseCodesEnum.Procedures ? true : false;
    this.medicalDiv = codeType == CaseCodesEnum.MedicalDevices ? true : false;
    this.venDiv = codeType == CaseCodesEnum.Vendors ? true : false;
    this.clearTextCodeVal(codeType);
    this.disableAllAddCodeDivs();
    this.icdAdd = codeType != CaseCodesEnum.Icd ? false : true;
    this.disableIcdAddButton = false;
    this.disableCptAddButton = false;
    this.disableCptAddButton = false;
    this.disablePreAddButton = false;
    this.disableMedAddButton = false;
    this.disableVenAddButton = false;
    this.showOverlay = false;
  }

  findItemAlreadyExist(codeType, itemId, itemName): number {
    switch (codeType) {
      case (CaseCodesEnum.Icd):
        {
          return this.icdLoadData.filter(icd => icd.id != itemId && icd.name == itemName).length;
        }
      case (CaseCodesEnum.Cpt):
        {
          return this.cptLoadData.filter(cpt => cpt.id != itemId && cpt.name == itemName).length;
        }
      case (CaseCodesEnum.Preoperatives):
        {
          return this.preLoadData.filter(pre => pre.id != itemId && pre.name == itemName).length;
        }
      case (CaseCodesEnum.Procedures):
        {
          return this.procLoadData.filter(proc => proc.id != itemId && proc.name == itemName).length;
        }
      case (CaseCodesEnum.MedicalDevices):
        {
          return this.medLoadData.filter(med => med.id != itemId && med.name == itemName).length;
        }
      case (CaseCodesEnum.Vendors):
        {
          return this.vendorLoadData.filter(vendor => vendor.id != itemId && vendor.name == itemName).length;
        }
    }

  }

  setDisableEditedItem(codeType, itemId) {
    switch (codeType) {
      case (CaseCodesEnum.Icd): {
        let itemIndex = this.icdLoadData.findIndex(icd => icd.id == itemId);
        this.icdLoadData[itemIndex].isEnabled = false;
        this.showIcdCodeLoader = false;
        break;
      }
      case (CaseCodesEnum.Cpt): {
        let itemIndex = this.cptLoadData.findIndex(cpt => cpt.id == itemId);
        this.cptLoadData[itemIndex].isEnabled = false;
        this.showCptCodeLoader = false;
        break;
      }
      case (CaseCodesEnum.Preoperatives): {
        let itemIndex = this.preLoadData.findIndex(pre => pre.id == itemId);
        this.preLoadData[itemIndex].isEnabled = false;
        this.showPreCodeLoader = false;
        break;
      }
      case (CaseCodesEnum.Procedures): {
        let itemIndex = this.procLoadData.findIndex(proc => proc.id == itemId);
        this.procLoadData[itemIndex].isEnabled = false;
        this.showProcCodeLoader = false;
        break;
      }
      case (CaseCodesEnum.MedicalDevices): {
        let itemIndex = this.medLoadData.findIndex(med => med.id == itemId);
        this.medLoadData[itemIndex].isEnabled = false;
        this.showMedCodeLoader = false;
        break;
      }
      case (CaseCodesEnum.Vendors): {
        let itemIndex = this.vendorLoadData.findIndex(vendor => vendor.id == itemId);
        this.vendorLoadData[itemIndex].isEnabled = false;
        this.showVendorCodeLoader = false;
        break;
      }

    }



  }




  setLoadDataInformation(codeType, itemId, title, description) {
    switch (codeType) {
      case (CaseCodesEnum.Icd): {
        let itemIndex = this.icdLoadData.findIndex(icd => icd.id == itemId);
        if (itemIndex != null && itemIndex != undefined) {
          this.icdLoadData[itemIndex].name = title;
          this.icdLoadData[itemIndex].desc = description;
        }
        break;
      }
      case (CaseCodesEnum.Cpt): {

        let itemIndex = this.cptLoadData.findIndex(cpt => cpt.id == itemId);
        if (itemIndex != null && itemIndex != undefined) {
          this.cptLoadData[itemIndex].name = title;
          this.cptLoadData[itemIndex].desc = description;
        }
        break;
      }
      case (CaseCodesEnum.Preoperatives): {
        let itemIndex = this.preLoadData.findIndex(pre => pre.id == itemId);
        if (itemIndex != null && itemIndex != undefined) {

          this.preLoadData[itemIndex].name = title;
          this.preLoadData[itemIndex].desc = description;
        }
        break;
      }
      case (CaseCodesEnum.Procedures): {
        let itemIndex = this.procLoadData.findIndex(proc => proc.id == itemId);
        if (itemIndex != null && itemIndex != undefined) {
          this.procLoadData[itemIndex].name = title;
          this.procLoadData[itemIndex].desc = description;
        }
        break;
      }
      case (CaseCodesEnum.MedicalDevices): {
        let itemIndex = this.medLoadData.findIndex(med => med.id == itemId);
        if (itemIndex != null && itemIndex != undefined) {
          this.medLoadData[itemIndex].name = title;
          this.medLoadData[itemIndex].desc = description;
        }
        break;
      }
      case (CaseCodesEnum.Vendors): {
        let itemIndex = this.vendorLoadData.findIndex(vendor => vendor.id == itemId);
        if (itemIndex != null && itemIndex != undefined) {
          this.vendorLoadData[itemIndex].name = title;
          this.vendorLoadData[itemIndex].desc = description;
        }
        break;
      }
    }
  }

  setListDataInformation(codeType, itemId, title, description) {
    switch (codeType) {
      case (CaseCodesEnum.Icd): {
        let itemIndex = this.icdList.findIndex(icd => icd.id == itemId);
        if (itemIndex != null && itemIndex != undefined) {
          this.icdList[itemIndex].name = title;
          this.icdList[itemIndex].desc = description;
        }
        break;
      }
      case (CaseCodesEnum.Cpt): {

        let itemIndex = this.cptList.findIndex(cpt => cpt.id == itemId);
        if (itemIndex != null && itemIndex != undefined) {
          this.cptList[itemIndex].name = title;
          this.cptList[itemIndex].desc = description;
        }
        break;
      }
      case (CaseCodesEnum.Preoperatives): {
        let itemIndex = this.preList.findIndex(pre => pre.id == itemId);
        if (itemIndex != null && itemIndex != undefined) {
          this.preList[itemIndex].name = title;
          this.preList[itemIndex].desc = description;
        }
        break;
      }
      case (CaseCodesEnum.Procedures): {
        let itemIndex = this.procList.findIndex(proc => proc.id == itemId);
        if (itemIndex != null && itemIndex != undefined) {
          this.procList[itemIndex].name = title;
          this.procList[itemIndex].desc = description;
        }
        break;
      }
      case (CaseCodesEnum.MedicalDevices): {
        let itemIndex = this.medList.findIndex(med => med.id == itemId);
        if (itemIndex != null && itemIndex != undefined) {
          this.medList[itemIndex].name = title;
          this.medList[itemIndex].desc = description;
        }
        break;
      }
      case (CaseCodesEnum.Vendors): {
        let itemIndex = this.venList.findIndex(vendor => vendor.id == itemId);
        if (itemIndex != null && itemIndex != undefined) {
          this.venList[itemIndex].name = title;
          this.venList[itemIndex].desc = description;
        }
        break;
      }

    }
  }



  updateCaseCode(codeType, title, description, itemId) {
    if (title.trim() == "" || title == null || title == undefined) {
      AlertMessages.Show("Warning", "Empty Field Not Allowed!!!", AlertType.Warning);
    }
    else {
      var indexVal = this.findItemAlreadyExist(codeType, itemId, title);
      if (indexVal > 0) {
        AlertMessages.Show("Warning", this.getCodeTypeName(codeType) + " Code already exists!!!", AlertType.Warning);
        this.setDisableEditedItem(codeType, itemId);
      }
      else {

        this._service.updateCaseItem(itemId, title, description, codeType).subscribe(
        (data) => {

          this.setLoadDataInformation(codeType, itemId, title, description);
          this.setDisableEditedItem(codeType, itemId);
          AlertMessages.Show("Codes", " " + data, AlertType.Add);
        },
        (error) => {
          AlertMessages.Show('Failed','Could not update!', AlertType.Error);
        });
      }
    }
  }

  saveIcdNew(nameField, descriptionField, helpTextField, categoryField) {
    this.sendAddData = new HaEditIcdModal();
    this.icdAddButton = true;
    if (nameField == "" || nameField == null || nameField == undefined) {
      AlertMessages.Show("Warning", "Please Enter Name", AlertType.Warning);
      this.icdAddButton = false;
    }
    else {
      let existCount = this.findItemAlreadyExist(CaseCodesEnum.Icd, '', nameField);
      if (existCount > 0) {
        AlertMessages.Show("Warning", "ICD Code Already exists!!!", AlertType.Warning);
        this.resetIcdData(false);
      }
      else {
        this.sendAddData.name = nameField;
        this.sendAddData.category = categoryField;
        this.sendAddData.description = descriptionField;
        this.sendAddData.helpText = helpTextField;
        this.sendAddData.isEditable = false;
        this._serv.insertIcdData(this.sendAddData).subscribe(
        (data: HaEditIcdModal) => {
          if (data.id == "" || data.id == undefined || data.id == null) {
            AlertMessages.Show("Warning", 'Code Not inserted', AlertType.Warning);

            this.resetIcdData(false);
          }  else {
            if (data.type == 2) {
              AlertMessages.Show("Success", 'Icd Code Added Successfully', AlertType.Success);
              this.icdData.push(data);
              this.icdLoadData.push({ "id": data.id, "name": nameField, "groupName": '', "desc": descriptionField, "isChecked": false });

              this.resetIcdData(false);
            }  else {
              AlertMessages.Show("Success", 'Icd Code Added Successfully', AlertType.Success);
              this.icdData.push(data);

              this.resetIcdData(false);
            }
          }
        },
        (error) => {
          AlertMessages.Show('Failed','Could not save!',AlertType.Error);
          // this.resetIcdData(false);
          this.icdAddButton = false;

        });
      }
    }
  }

  //----------------------------------------------------------574
  resetIcdData(type) {
    this.nameFieldDataIcd = "";
    this.descriptionFieldDataIcd = "";
    this.categoryFieldDataIcd = "";
    this.helpTextFieldDataIcd = "";
    if(type) this.dataModelIcd = "";
    this.icdAddButton = type;
  }

  resetCptData() {
      this.nameFieldData = "";
      this.descriptionFieldData = "";
      this.categoryFieldData = "";
      this.helpTextFieldData = "";
      this.dataModelCpt = "";
      this.cptAddButton = false;
  }


  saveCptNew(nameField, descriptionField, helpTextField, categoryField) {
    this.sendAddDataCpt = new HaEditIcdModal();
    this.cptAddButton = true;
    if (nameField == "" || nameField == null || nameField == undefined) {
      AlertMessages.Show("Warning", 'Please Enter Name', AlertType.Warning);
      this.cptAddButton = false;
    } else {
      let existCount = this.findItemAlreadyExist(CaseCodesEnum.Cpt, '', nameField);
      if (existCount > 0) {
        AlertMessages.Show("Warning", "CPT Code Already exists!!!", AlertType.Warning);
        this.resetCptData();
      } else {
        if (descriptionField == undefined || descriptionField == null) {
          descriptionField = "";
        }
        this.sendAddDataCpt.name = nameField;
        this.sendAddDataCpt.category = categoryField;
        this.sendAddDataCpt.description = descriptionField;
        this.sendAddDataCpt.helpText = helpTextField;
        this.sendAddDataCpt.isEditable = false;
        this._serv.insertCptData(this.sendAddDataCpt).subscribe(
        (data: HaEditIcdModal) => {
          if (data.id == "" || data.id == undefined || data.id == null) {
            AlertMessages.Show("Warning", 'Code Not inserted', AlertType.Warning);
            this.resetCptData();
          } else {
            if (data.type == 2) {
              AlertMessages.Show("Success", 'Cpt Code Added Successfully', AlertType.Success);
              this.cptData.push(data);
              this.cptLoadData.push({ "id": data.id, "name": nameField, "groupName": '', "desc": descriptionField, "isChecked": false });
              this.resetCptData();
            }
            else {
              AlertMessages.Show("Success", 'Cpt Code Added Successfully', AlertType.Success);
              this.cptData.push(data);
              this.resetCptData();
            }
          }
        },
        (error) => {
          AlertMessages.Show('Failed','Could not save!', AlertType.Error);
          // this.resetCptData();
          this.cptAddButton = false;
        });
      }
    }
  }

  //codes except icd and cpt are getting stored without any tree structure  and description
  saveCaseCode(codeType, title) {
    if (title.trim() == "") {
      alert("Please Fiil required details");
    } else {
      let existCount = this.findItemAlreadyExist(codeType, null, title);
      if (existCount > 0) {

        AlertMessages.Show("Warning", this.getCodeTypeName(codeType) + " Code Already exists!!!", AlertType.Warning);
        this.disableAllAddCodeDivs();
        this.resetTextValues();
        this.disableAddCodeButton(codeType);
      }
      else {
        // let res = confirm("Are you sure you want to add code?");
        // if (res == true) {
        if (this._service.saveCodes(title, "", codeType).subscribe) {
          this._service.saveCodes(title, "", codeType).subscribe(
          (data) => {
            this.resetTextValues();
           this.pushAddedCodes(codeType,data,title)
            AlertMessages.Show("Success", "Added", AlertType.Success);
            this.disableAllAddCodeDivs();
            this.disableAddCodeButton(codeType);
          },
          (error) => {
            AlertMessages.Show('Failed','Could not Add Code!', AlertType.Error);
          });
        }
      }
    }

  }

  resetTextValues() {
    this.medTextVal = "";
    this.icdTextVal = "";
    this.icdDescVal = "";
    this.cptTextVal = "";
    this.cptDescVal = "";
    this.preTextVal = "";
    this.procTextVal = "";
    this.venTextVal = "";
  }

  disableAllAddCodeDivs() {
    this.icdAdd = false;
    this.medAdd = false;
    this.cptAdd = false;
    this.preAdd = false;
    this.procAdd = false;
    this.vendorAdd = false;
  }

  changeAddCodeDiv(index) {
    this.icdAdd = index == CaseCodesEnum.Icd;
    this.medAdd = index == CaseCodesEnum.MedicalDevices;
    this.cptAdd = index == CaseCodesEnum.Cpt;
    this.preAdd = index == CaseCodesEnum.Preoperatives;
    this.procAdd = index == CaseCodesEnum.Procedures;
    this.vendorAdd = index == CaseCodesEnum.Vendors;
  }

  getCodeTypeName(codeType): string {
    switch (codeType) {
      case (CaseCodesEnum.Icd): {
        return "Icd";

      }
      case (CaseCodesEnum.Cpt): {
        return "Cpt";

      }
      case (CaseCodesEnum.Preoperatives): {
        return "Preoperatives";
      }
      case (CaseCodesEnum.Procedures): {
        return "Procedures";
      }
      case (CaseCodesEnum.MedicalDevices): {
        return "Medical Devices";
      }
      case (CaseCodesEnum.Vendors): {
        return "Vendors";
      }

    }

  }


  pushAddedCodes(codeType,data,title:string) {
    switch (codeType) {

      case (CaseCodesEnum.Preoperatives): {
        this.preLoadData.push({ "id": data, "name": title, "groupName": '', "desc": '', "isChecked": false });

        break;
      }
      case (CaseCodesEnum.Procedures): {
        this.procLoadData.push({ "id": data, "name": title, "groupName": '', "desc": '', "isChecked": false });

        break;
      }
      case (CaseCodesEnum.MedicalDevices): {
        this.medLoadData.push({ "id": data, "name": title, "groupName": '', "desc": '', "isChecked": false });

        break;
      }
      case (CaseCodesEnum.Vendors): {
        this.vendorLoadData.push({ "id": data, "name": title, "groupName": '', "desc": '', "isChecked": false });

        break;
      }
    }
  }



  disableAddCodeButton(codeType) {
    switch (codeType) {

      case (CaseCodesEnum.Preoperatives): {
        this.disablePreAddButton = false;
        break;
      }
      case (CaseCodesEnum.Procedures): {
        this.disableProcAddButton = false;
        break;
      }
      case (CaseCodesEnum.MedicalDevices): {
        this.disableMedAddButton = false;
        break;
      }
      case (CaseCodesEnum.Vendors): {
        this.disableVenAddButton = false;
        break;
      }
    }
  }

  displayAddFunc(codeType) {
    this.resetTextValues();
    switch (codeType) {
      case (CaseCodesEnum.Preoperatives): {
        this.changeAddCodeDiv(CaseCodesEnum.Preoperatives);
        break;
      }
      case (CaseCodesEnum.Procedures): {
        this.changeAddCodeDiv(CaseCodesEnum.Procedures);
        break;
      }
      case (CaseCodesEnum.MedicalDevices): {
        this.changeAddCodeDiv(CaseCodesEnum.MedicalDevices);
        break;
      }
      case (CaseCodesEnum.Vendors): {
        this.changeAddCodeDiv(CaseCodesEnum.Vendors);
        break;
      }
    }
  }

  cancelAddFunc(codeType) {
    this.disableAllAddCodeDivs();
    this.resetTextValues();

    switch (codeType) {
      case (CaseCodesEnum.Preoperatives): {
        this.disableAddCodeButton(CaseCodesEnum.Preoperatives);
        break;
      }
      case (CaseCodesEnum.Procedures): {
        this.disableAddCodeButton(CaseCodesEnum.Procedures);
        break;
      }
      case (CaseCodesEnum.MedicalDevices): {
        this.disableAddCodeButton(CaseCodesEnum.MedicalDevices);
        break;
      }
      case (CaseCodesEnum.Vendors): {
        this.disableAddCodeButton(CaseCodesEnum.Vendors);
        break;
      }
    }
  }

  storeCode(event, id, desc, name, codeType) {

    if (event.target.checked == true) {
      switch (codeType) {
        case CaseCodesEnum.Icd: {
          this.icdList.push({ "id": id, "desc": desc, "name": name, "isChecked": true });
          break;
        }
        case CaseCodesEnum.Cpt: {
          this.cptList.push({ "id": id, "desc": desc, "name": name, "isChecked": true });
          break;
        }
        case CaseCodesEnum.Preoperatives: {
          this.preList.push({ "id": id, "desc": desc, "name": name, "isChecked": true });
          break;
        }
        case CaseCodesEnum.Procedures: {
          this.procList.push({ "id": id, "desc": desc, "name": name, "isChecked": true });
          break;
        }
        case CaseCodesEnum.MedicalDevices: {
          this.medList.push({ "id": id, "desc": desc, "name": name, "isChecked": true });
          break;
        }
        case CaseCodesEnum.Vendors: {
          this.venList.push({ "id": id, "desc": desc, "name": name, "isChecked": true });
          break;
        }
      }

    }

    else {
      switch (codeType) {
        case CaseCodesEnum.Icd: {
          var itemIndex = this.icdList.findIndex(ij => ij.id == id);
          if (itemIndex !== undefined) {
            this.icdList.splice(itemIndex, 1);
          }
          break;
        }
        case CaseCodesEnum.Cpt: {
          var itemIndex = this.cptList.findIndex(ij => ij.id == id);
          if (itemIndex !== undefined) {
            this.cptList.splice(itemIndex, 1);
          }
          break;
        }
        case CaseCodesEnum.Preoperatives: {
          var itemIndex = this.preList.findIndex(ij => ij.id == id);
          if (itemIndex !== undefined) {
            this.preList.splice(itemIndex, 1);
          }
          break;
        }
        case CaseCodesEnum.Procedures: {
          var itemIndex = this.procList.findIndex(ij => ij.id == id);
          if (itemIndex !== undefined) {
            this.procList.splice(itemIndex, 1);
          }
          break;
        }
        case CaseCodesEnum.MedicalDevices: {
          var itemIndex = this.medList.findIndex(ij => ij.id == id);
          if (itemIndex !== undefined) {
            this.medList.splice(itemIndex, 1);
          }
          break;
        }
        case CaseCodesEnum.Vendors: {
          var itemIndex = this.venList.findIndex(ij => ij.id == id);
          if (itemIndex !== undefined) {
            this.venList.splice(itemIndex, 1);
          }
          break;
        }
      }
    }
  }

  alertCloseGroup() {
    setTimeout(() => {

      this.router.navigate(['Hospital/HAAdmin/CaseGroupCreation'], {});
    }, 1000);

  }

  routeBack() {
    this.router.navigate(['Hospital/HAAdmin/CaseGroupCreation'], {});
  }

  saveGroup(groupName) {
    this.showSaveLoader = true;
    if (groupName == "") {
      AlertMessages.Show("Warning", "Please Enter Group Name!!!", AlertType.Warning);
      this.showSaveLoader = false;
    } else {

      if (this.icdList.length <= 0 && this.cptList.length <= 0 && this.preList.length <= 0 && this.procList.length <= 0 && this.medList.length <= 0 && this.venList.length <= 0) {
        AlertMessages.Show("Warning", "Please Add codes to Group!!!", AlertType.Warning);
        this.showSaveLoader = false;
      } else {
        let groupModal:CreateGroupModal = new CreateGroupModal(groupName, this.icdList, this.cptList, this.preList, this.procList, this.medList, this.venList);
        this._service.createGroupAndCodes(groupModal).subscribe(
        (data) => {
          this.alertCloseGroup();
          AlertMessages.Show("Success", data as string, AlertType.Success);
        },
        (error) => {
          AlertMessages.Show('Failed','Could Not Save Group!', AlertType.Error);
        }).add(() => {
          this.showSaveLoader = false;
        });
      }

    }
  }

  //checking for duplicate group Name
  getCaseByGroup() {
    this._service.getCaseGroupList().subscribe(
    (data: any[]) => {
      this.caseGroupList = data;
    },
    (error) => {
      AlertMessages.Show('Failed','Could not load groups', AlertType.Error);
      this.getCodes('1');
    });
  }

  getCaseGroupList(groupName) {
    this.saveDisable = true;

    if (this.caseGroupList !== undefined) {
      var indexVal = this.caseGroupList.filter(caseGroup => caseGroup.name.toLowerCase().trim() == groupName.toLowerCase().trim())[0];
      if (indexVal !== undefined) {
        this.groupVal = "";
        AlertMessages.Show("Warning", "Group Name already exists!!!", AlertType.Warning);
        this.saveDisable = true;
      }
      else {
        this.saveDisable = false;
      }
    }
  }





}
